import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeeleven-courses',
  templateUrl: './homeeleven-courses.component.html',
  styleUrls: ['./homeeleven-courses.component.scss']
})
export class HomeelevenCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
